import {createAction} from 'redux-actions';
import * as ACTION from './constants';

export const deletePackage = createAction(ACTION.DELETE_PACKAGE.REQUEST, (bagId, packingId) => ({bagId, packingId}));
export const beginDeletePackage = createAction(ACTION.BEGIN_DELETE_PACKAGE, () => {});
export const endDeletePackage = createAction(ACTION.END_DELETE_PACKAGE, () => {});

export const removePackage = createAction(ACTION.REMOVE_PACKAGE.REQUEST, (bagId, packageId) => ({bagId, packageId}));